import {
    ConfigurationParameters,
    Configuration,
    DpartementApi,
    GreffeApi,
} from '../../openApi/ApiGeoloc';

/**
 * Configuration
 */

export function buildGeolocRedux(configGeoloc: ConfigurationParameters) {
    const geolocConfiguration = new Configuration(configGeoloc);

    const departmentApi = new DpartementApi(geolocConfiguration);
    const greffeApi = new GreffeApi(geolocConfiguration);

    return {
        serviceConfiguration: geolocConfiguration,
        serviceConfigurationParameters: configGeoloc,
        apis: {
            departmentApi,
            greffeApi,
        },
        thunks: {},
        slices: {},
        fetchItems: {},
        getItems: {},
        models: {},
    };
}
